<template>
  <el-dialog
    title="扩展设置"
    :visible.sync="showDialog"
    :append-to-body="true"
    width="60%"
  >
    <el-form ref="form" :model="fields" label-width="120px" size="small">
      <el-form-item label="商品名称">
        {{ goodsTitle }}
      </el-form-item>
      <el-form-item label="购买时间限制">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-input v-model="fields.buy_day">
              <template slot="append">天</template>
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input v-model="fields.buy_hour">
              <template slot="append">时</template>
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input v-model="fields.buy_min">
              <template slot="append">分</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="可购买最长时长">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-input v-model="fields.most_buy_day">
              <template slot="append">天</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="退款时间限制">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-select v-model="fields.refund_type" placeholder="请选择">
              <el-option label="出行当天23:59分前" :value="1"></el-option>
              <el-option label="出行当天23:59分后" :value="2"></el-option>
              <el-option label="随时退" :value="3"></el-option>
              <el-option label="联系客服退款" :value="4"></el-option>
              <el-option label="航班开始前" :value="5"></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-input v-model="fields.refund_day"
                      :disabled="fields.refund_type === 3 || fields.refund_type === 4 || fields.refund_type === 5">
              <template slot="append">天</template>
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input v-model="fields.refund_hour"
                      :disabled="fields.refund_type === 3 || fields.refund_type === 4|| fields.refund_type === 5">
              <template slot="append">小时</template>
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input v-model="fields.refund_min" :disabled="fields.refund_type === 3 || fields.refund_type === 4">
              <template slot="append">分钟</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="退票费规则">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-select v-model="fields.refund_fee_type" placeholder="请选择">
              <el-option label="退票费" :value="1"></el-option>
              <el-option label="固定金额" :value="2"></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-input v-model="fields.refund_fee">
              <template slot="append">元</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="人工审核退票">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-radio v-model="fields.auto_refund" :label="-1">是</el-radio>
            <el-radio v-model="fields.auto_refund" :label="1">否</el-radio>
          </el-col>
          <el-col :span="5">
            <el-tag type="danger">选择非人工审核将自动退票</el-tag>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="是否需要证件">
        <el-col :span="5">
          <el-select v-model="fields.need_card" placeholder="请选择">
            <el-option label="不需要" :value="0"></el-option>
            <el-option label="需要一个人" :value="1"></el-option>
            <el-option label="全部游客都需要" :value="2"></el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="年龄优惠">
        <el-row :gutter="10" v-for="(age,index) in fields.age_discount" style="margin-bottom: 10px">
          <el-col :span="5">
            <el-input v-model="age.low_limit">
              <template slot="prepend">年龄下限</template>
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input v-model="age.high_limit">
              <template slot="prepend">年龄上限</template>
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input v-model="age.title">
              <template slot="prepend">优惠名称</template>
            </el-input>
          </el-col>
          <el-col :span="6">
            <el-input v-model="age.price" :disabled="age.is_free">
              <template slot="prepend">优惠金额</template>
              <template slot="append">
                元
                <el-switch
                  v-model="age.is_free"
                />  免费
              </template>
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button size="mini" type="danger" @click="delDiscount(index)">删除</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-button @click="addAgeDiscount">
            增加优惠类型
          </el-button>
        </el-row>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="hide">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="setExtension">确
        定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "i-extension",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    productId: {},
    goodsTitle: {
      type: String
    }
  },
  data() {
    return {
      showDialog: false,
      loading: false,
      fields: {
        buy_day: 0,
        buy_hour: 0,
        buy_min: 0,
        check_min: 0,
        need_card: 0,
        most_buy_day: 60,
        refund_type: 1,
        refund_day: 0,
        refund_hour: 0,
        refund_min: 0,
        refund_fee: 0,
        refund_fee_type: 1,
        auto_refund: -1,
        age_discount: [],
      }
    }
  },
  methods: {
    hide: function () {
      this.showDialog = false;
    },
    setExtension: function () {
      this.loading = true;
      this.fields.pid = this.productId;
      this.$http.request('setExtension', this.fields).then((res) => {
        this.loading = false;
        if (res.status === 'success') {
          this.$message({
            message: res.message,
            type: 'success',
            onClose: () => {
              this.hide();
            }
          });
        }
      });
    },
    getExtension: function () {
      if (!this.productId) {
        return;
      }
      this.$http.request('getExtension', {pid: this.productId}).then((res) => {
        if (res.data.hasOwnProperty('pid')) {
          this.fields = res.data;
        } else {
          this.fields = {
            buy_day: 0,
            buy_hour: 0,
            buy_min: 0,
            check_day: 0,
            check_hour: 0,
            check_min: 0,
            need_card: 0
          }
        }
      })
    },
    addAgeDiscount: function () {
      console.log( this.fields)
      this.fields.age_discount.push({
        low_limit: "",
        high_limit: "",
        title: "",
        price: "",
        is_free: false,
      });
    },
    delDiscount: function (index) {
      this.fields.age_discount.splice(index, 1);
    }
  },
  created: function () {
    this.getExtension();
  },
  watch: {
    show: function () {
      this.showDialog = this.show;
    },
    showDialog: function () {
      this.$emit('change', this.showDialog);
    },
    productId: function () {
      this.getExtension();
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/i-extension.vue